import { motion } from 'framer-motion';
import OnboardingMascotVideo from '@/components/mascot/OnboardingMascotVideo';
import SpeechBubble from '@/components/ui/SpeechBubble';
import TypingText from '@/components/ui/TypingText';
import BackArrow from '@/components/ui/BackArrow';
import { pageItem } from '@/utils/animations';

interface OnboardingGuideHeaderProps {
  text: string;
  onBack: () => void;
  replayKey?: number;
  hideBackButton?: boolean;
  showLaterButton?: boolean;
  onLater?: () => void;
  progressStep?: number;
  progressTotal?: number;
}

const OnboardingGuideHeader = ({
  text,
  onBack,
  replayKey = 0,
  hideBackButton = false,
  showLaterButton = false,
  onLater,
  progressStep = 1,
  progressTotal = 8,
}: OnboardingGuideHeaderProps) => {
  const progressPercent = Math.min(100, Math.max(0, (progressStep / progressTotal) * 100));

  return (
    <div 
      id="onboarding-guide-header" 
      className="fixed top-0 left-0 right-0 z-[120] bg-white pt-safe-top"
      style={{ paddingTop: 'env(safe-area-inset-top)' }}
    >
      <div className="max-w-4xl mx-auto px-3 pt-2 pb-1 relative">
        {!hideBackButton && (
          <motion.div className="absolute top-2 right-3 z-10" variants={pageItem}>
            <BackArrow onClick={onBack} className="scale-75 origin-top-right" />
          </motion.div>
        )}
        {showLaterButton && onLater && (
          <motion.button
            type="button"
            onClick={onLater}
            className="absolute top-3 left-3 z-10 inline-flex h-8 items-center rounded-lg border border-gray-200 bg-white px-2.5 text-sm font-persian font-medium text-gray-600 shadow-sm transition-colors hover:bg-gray-50 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-primary-400"
            variants={pageItem}
            aria-label="ادامه بدون ثبت‌نام"
          >
            <span>بعدا.فعلا حوصله ندارم</span>
          </motion.button>
        )}
        <motion.div className="mt-11 w-full px-5" variants={pageItem}>
          <div
            className="h-4 w-full overflow-hidden rounded-full bg-gray-200"
            role="progressbar"
            aria-label="پیشرفت مراحل ثبت‌نام"
            aria-valuemin={1}
            aria-valuemax={progressTotal}
            aria-valuenow={progressStep}
          >
            <div
              className="h-full rounded-full bg-primary-500 transition-[width] duration-500 ease-out"
              style={{ width: `${progressPercent}%` }}
            />
          </div>
        </motion.div>
        <motion.div className="mt-2 flex flex-row items-center gap-2" variants={pageItem}>
          <OnboardingMascotVideo />
          <SpeechBubble position="left" animated className="flex-1">
            <TypingText text={text} replayKey={replayKey} speedMs={55} />
          </SpeechBubble>
        </motion.div>
      </div>
    </div>
  );
};

export default OnboardingGuideHeader;
